export default "__VITE_ASSET__daca2926__"